module.exports = __webpack_public_path__ + "img/card_2.c016d8eb.png";